<script lang="ts">
  export let colour: string = '#808A9F';
  export let width: number = 24;
  export let height: number = 24;
</script>

<svg xmlns="http://www.w3.org/2000/svg" {width} {height} fill="none"
  ><path
    fill={colour}
    d="M2.5 7.5v5h3.333L10 16.667V3.333L5.833 7.5H2.5ZM13.75 10a3.75 3.75 0 0 0-2.083-3.358v6.708A3.728 3.728 0 0 0 13.75 10Zm-2.083-7.308v1.716A5.838 5.838 0 0 1 15.833 10a5.838 5.838 0 0 1-4.166 5.592v1.716A7.497 7.497 0 0 0 17.5 10a7.497 7.497 0 0 0-5.833-7.308Z"
    style="fill:{colour};fill-opacity:1"
  /></svg
>
